
import { ACTUALIZAR_INDICADOR_HABILITADO } from "./types";

export type IndicadorKey =
    | "UTM"
    | "UF"
    | "Dólar"
    | "IPC"
    | "BTC"
    | "EURO"
    | "Ethereum";

export interface ActualizarIndicadorHabilitadoPayload {
    id: IndicadorKey;
    habilitado: boolean;
}

export const actualizarIndicadorHabilitadoActions = (
    id: IndicadorKey,
    habilitado: boolean
) => ({
    type: ACTUALIZAR_INDICADOR_HABILITADO,
    payload: {
        id,
        habilitado,
    },
});
